import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AEM_FUNCTIONS } from '@yme/common/aem-functions';
import { CLP_TYPE, PLP_TYPE } from '@yme/common/constants';
import { useDispatch } from '@yme/hooks/useDispatch';
import { setPrevPageType, getPrevPageType } from '@yme/pdp-components/ProductCard';
import { getPageType } from '@yme/selectors/common';
export const usePageType = (cqType = '') => {
    const pageType = useSelector(getPageType);
    const prevPageType = useSelector(getPrevPageType);
    const dispatch = useDispatch();
    useEffect(() => {
        const isRedirectFromListingPage = prevPageType === CLP_TYPE || prevPageType === PLP_TYPE;
        if (cqType === AEM_FUNCTIONS.clpUnitsGrid ||
            cqType === AEM_FUNCTIONS.plpUnitsGrid ||
            !isRedirectFromListingPage) {
            dispatch(setPrevPageType(pageType));
        }
    }, [cqType, dispatch, pageType, prevPageType]);
};
